/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
/** input type for inserting data into table "additional_address" */
export type Additional_Address_Insert_Input = {
  address_1?: string | null | undefined;
  address_2?: string | null | undefined;
  city?: string | null | undefined;
  country?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  postal_code?: string | null | undefined;
};

export type UpsertAdditionalAddressMutationVariables = Exact<{
  address: Types.Additional_Address_Insert_Input;
}>;


export type UpsertAdditionalAddressMutation = { insert_additional_address_one: { id: string } | null };


export const UpsertAdditionalAddressDocument = /*#__PURE__*/ gql`
    mutation upsertAdditionalAddress($address: additional_address_insert_input!) {
  insert_additional_address_one(
    object: $address
    on_conflict: {constraint: additional_address_pkey, update_columns: [address_1, address_2, city, country, name, postal_code]}
  ) {
    id
  }
}
    `;
export type UpsertAdditionalAddressMutationFn = Apollo.MutationFunction<UpsertAdditionalAddressMutation, UpsertAdditionalAddressMutationVariables>;

/**
 * __useUpsertAdditionalAddressMutation__
 *
 * To run a mutation, you first call `useUpsertAdditionalAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAdditionalAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAdditionalAddressMutation, { data, loading, error }] = useUpsertAdditionalAddressMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpsertAdditionalAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAdditionalAddressMutation, UpsertAdditionalAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAdditionalAddressMutation, UpsertAdditionalAddressMutationVariables>(UpsertAdditionalAddressDocument, options);
      }
export type UpsertAdditionalAddressMutationHookResult = ReturnType<typeof useUpsertAdditionalAddressMutation>;
export type UpsertAdditionalAddressMutationResult = Apollo.MutationResult<UpsertAdditionalAddressMutation>;
export type UpsertAdditionalAddressMutationOptions = Apollo.BaseMutationOptions<UpsertAdditionalAddressMutation, UpsertAdditionalAddressMutationVariables>;